import colors from '../theme/colors';
import palette from '../theme/palette';

const styleOverrides = {
  root: {
    [`&.Mui-hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline`]: {
      // @TODO Instead of :not(focused), this should work with :hover only. Maybe it's a bug.
      borderColor: colors.solidGray[500],
    },
    [`&:hover .MuiOutlinedInput-notchedOutline`]: {
      borderColor: colors.solidGray[500],
    },
    [`&.Mui-disabled .MuiOutlinedInput-notchedOutline`]: {
      borderColor: colors.solidGray[200],
    },
    [`&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline`]: {
      borderColor: colors.solidGray[200],
    },
  },
  colorPrimary: {
    [`&.Mui-focused .MuiOutlinedInput-notchedOutline`]: {
      borderColor: colors.brandPrimary[400],
    },
    [`&.Mui-error .MuiOutlinedInput-notchedOutline`]: {
      borderColor: palette.error.main,
    },
  },
  input: {
    padding: '10px 12px',
  },
  inputAdornedStart: {
    paddingLeft: 8,
  },
  inputAdornedEnd: {
    paddingRight: 8,
  },
  notchedOutline: {
    borderColor: colors.solidGray[500],
  },
};

export default styleOverrides;
